import { RuleProps } from 'types/application';

export const SECT_ORGANISATION = 'organisation';

export const ORGANISATION_FIELDS = [
    {
        sectionID: SECT_ORGANISATION,
        sectionName: '',
        fieldList: [
            {
                id: 'name',
                label: 'Name',
                type: 'text',
                rule: {
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    },
                    required: true,
                    charLength: 66
                }
            },
            {
                id: 'uen',
                label: 'UEN No.',
                type: 'text',
                rule: { disabled: true, required: true, charLength: 10 }
            },
            {
                id: 'company-name',
                label: 'Company Name',
                type: 'text',
                required: true,
                charLength: 50,
                rule: {
                    disabled: ({ myInfoAutoFill }: RuleProps) => {
                        return myInfoAutoFill;
                    },
                    required: true,
                    charLength: 50
                }
            },
            {
                id: 'mobile-no',
                label: 'Mobile No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry-no- Code',
                    apiID: 'MobileNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65'
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    // rule: [
                    //     {
                    //         baseField: `${SECT_ORGANISATION}-mobile-no-country-code`,
                    //         ifList: ['65'],
                    //         charLength: 8,
                    //         pattern: /^[89][0-9]{7}$/
                    //     },
                    //     {
                    //         baseField: `${SECT_ORGANISATION}-mobile-no-country-code`,
                    //         ifNotList: ['65'],
                    //         charLength: 12
                    //     }
                    // ]
                    rule: {
                        required: true,
                        baseIds: [`${SECT_ORGANISATION}-mobile-no-country-code`],
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-mobile-no-country-code`] === '65');
                            return isSG ? /^[89][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-mobile-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'office-no',
                label: 'Office No.',
                type: 'combo',
                rule: { required: true },
                preField: {
                    id: 'country-code',
                    label: 'Coutry Code',
                    apiID: 'OfficeNoCountryCode',
                    type: 'dropdown',
                    options: [{ optID: '65', optLabel: '+65' }],
                    defaultValue: '65',
                    rule: { disabled: true }
                },
                mainField: {
                    id: 'main',
                    type: 'number',
                    // rule: [
                    //     {
                    //         baseField: `${SECT_ORGANISATION}-office-no-country-code`,
                    //         ifList: ['65'],
                    //         charLength: 8,
                    //         pattern: /^[3689][0-9]{7}$/
                    //     },
                    //     {
                    //         baseField: `${SECT_ORGANISATION}-office-no-country-code`,
                    //         ifNotList: ['65'],
                    //         charLength: 12
                    //     }
                    // ]
                    rule: {
                        baseIds: [`${SECT_ORGANISATION}-office-no-country-code`],
                        required: true,
                        pattern: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-office-no-country-code`] === '65');
                            return isSG ? /^[3689][0-9]{7}$/ : undefined;
                        },
                        charLength: ({ baseValues }: RuleProps) => {
                            const isSG = Boolean(baseValues && baseValues[`${SECT_ORGANISATION}-office-no-country-code`] === '65');
                            return isSG ? 8 : 12;
                        }
                    }
                }
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'email',
                rule: { required: true, charLength: 50 }
            },
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'dropdown',
                rule: { required: true, charLength: 10 }
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${SECT_ORGANISATION}-postal`],
                    required: true,
                    charLength: 32
                }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 }
            }
        ]
    }
];
